import allAvaliableTypes from './allAvaliableTypes'
import loadDetailsTypes from '../loadDetails/loadDetailsTypes'

export const initialState = {
  filters: {
    originLocations: [],
    destinationLocations: [],
    equipmentsTypes: [],
    from: { value: 'origin' },
    manageStatus: [],
    movementNumber: '',
    radius: 0,
    offset: 0
  },
  loadMore: false,
  loadPage: true,
  error: '',
  loads: [],
  noMore: false
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case allAvaliableTypes.GET_LOADS:
      return {
        ...state,
        loadMore: true,
        error: ''
      }

    case allAvaliableTypes.GET_LOADS_SUCCESS: {
      const { offset } = state.filters

      let { data: loads, results } = payload
      let noMore = false

      if (offset !== 0) {
        loads = [...state.loads, ...loads]
      }
      if (loads.length >= results) {
        noMore = true
      }
      return {
        ...state,
        loads,
        noMore,
        loadMore: false,
        loadPage: false,
        error: ''
      }
    }

    case allAvaliableTypes.GET_LOADS_FAILURE: {
      return {
        ...state,
        loadMore: false,
        loadPage: false,
        error: payload,
        loads: []
      }
    }
    case allAvaliableTypes.CLEAR_LOADS: {
      return {
        ...state,
        loads: []
      }
    }

    case allAvaliableTypes.MARK_FAVORITE_SUCCESS: {
      const { movementNumber, isMark } = payload
      const loads = state.loads.map(load => {
        if (load.movementNumber === movementNumber) {
          load.marked = isMark ? 0 : 1
        }
        return load
      })

      return {
        ...state,
        loads
      }
    }

    case allAvaliableTypes.SEARCH_BY_MOVEMENT_NUMBER: {
      return {
        ...state,
        filters: {
          ...initialState.filters,
          movementNumber: payload
        },
        loadPage: true
      }
    }

    case allAvaliableTypes.SET_FILTERS : {
      const filters = (!payload) ? { ...initialState.filters } : {
        ...state.filters,
        ...payload,
        offset: 0
      }

      return {
        ...state,
        filters,
        loadPage: true
      }
    }

    case allAvaliableTypes.LOAD_MORE:
      return {
        ...state,
        filters: {
          ...state.filters,
          offset: state.filters.offset + payload
        },
        loadMore: true
      }

    case loadDetailsTypes.BID_ORDER_SUCCESS: {
      const bidLoad = state.loads.find(load => load.movementNumber === payload.movement_id)
      const updatedLoads = state.loads.map(load => load.movementNumber === payload.movement_id
        ? {
          ...bidLoad,
          order_status: 'BID'
        }
        : load
      )
      return {
        ...state,
        loads: [...updatedLoads]
      }
    }

    case loadDetailsTypes.BOOK_ORDER_SUCCESS: {
      const bookedLoad = state.loads.find(load => load.movementNumber === payload.movement_id)
      const updatedLoads = state.loads.map(load => load.movementNumber === payload.movement_id
        ? {
          ...bookedLoad,
          order_status: 'BOOK'
        }
        : load
      )
      return {
        ...state,
        loads: [...updatedLoads]
      }
    }
    default: return state
  }
}
